import { ControllerProps } from "csi/middleware/common";
import { useLocalReactionStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { ProductHierarchySelectStoreContext } from "./ProductHierarchySelectStore";
import { createProductHierarchySelectStore } from "./ProductHierarchySelectService";
import ProductHierarchySingleSelect from "./ProductHierarchySingleSelect";

export interface ProductHierarchySelectProps extends ControllerProps {
    onChange?(value: string): void;
    error?: boolean;
}

const ProductHierarchySelect: FunctionComponent<ProductHierarchySelectProps> = observer((props) => {
	const { actionController, onChange, error, ...otherProps } = props;
	const locale = useLocale();
	const store = useLocalReactionStore(() => createProductHierarchySelectStore(actionController, locale, onChange));
	const {
		folderTypeNames,
	} = store || {};

	return (
		store && (
			<ProductHierarchySelectStoreContext.Provider value={store}>
				{folderTypeNames.map((value, index) => (
					<ProductHierarchySingleSelect
						error={error}
						i={index}
						key={index}
						label={value}
					/>
				))}
			</ProductHierarchySelectStoreContext.Provider>
		)
	);
});

export default ProductHierarchySelect;

